import type { MenuKeys } from '@/types';
import type { AxiosInstance, AxiosResponse } from 'axios';

class MenuService {
    private readonly apiService;

    constructor(apiService: AxiosInstance) {
        this.apiService = apiService;
    }

    index(): Promise<AxiosResponse<{ data: MenuKeys }>> {
        return this.apiService.get('/api/menu');
    }
}

export default MenuService;
